import React, { useRef, useState } from "react";
import BackHeader from "../../../components/BackHeader/BackHeader";
import styles from "./Listening.module.scss";
import AudioPlayer from "react-h5-audio-player";
import "react-h5-audio-player/lib/styles.css";

const Listening = () => {
  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const handlePlay = () => {
    if (isPlaying) {
      audioRef.current.audio.current.pause();
    } else {
      audioRef.current.audio.current.play();
    }
  };

  return (
    <div className={styles.container}>
      <BackHeader />
      <div>
        <h1>Listening Test </h1>
        <div className={styles.audioPlayer}>
          <AudioPlayer
            ref={audioRef}
            src="https://samplelib.com/lib/preview/mp3/sample-3s.mp3"
            onPlay={(e) => setIsPlaying(true)}
            onPause={(e) => setIsPlaying(false)}
            showSkipControls={false}
            showJumpControls={false}
            showFilledVolume={false}
            customAdditionalControls={[]}
            customVolumeControls={[]}
            customControlsSection={[]}
          />
        </div>

        <div className={styles.playButton}>
          <button
            className="btn btn-primary w-100"
            type="submit"
            onClick={handlePlay}
          >
            {isPlaying ? "Pause" : "Play"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Listening;
